import { type FC, type MouseEventHandler } from 'react';
import { Button } from '@mantine/core';
import { useApprovePayinOrder } from '~/entities/payin';

interface ApproveProps {
    id: string;
    disabled?: boolean;
    onSuccess?: () => void;
    onError?: (error: Error) => void;
}

export const Approve: FC<ApproveProps> = ({ id, disabled, onSuccess, onError }) => {
    const { mutate, isPending } = useApprovePayinOrder({ onSuccess, onError });

    const handleApprove: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        mutate({
            orderId: {
                value: id,
            },
        });
    };

    return (
        <Button
            title='Подтвердить получение'
            loading={isPending}
            onClick={handleApprove}
            disabled={isPending || disabled}
        >
            Подтвердить получение
        </Button>
    );
};
